import { render, staticRenderFns } from "./NoSections.vue?vue&type=template&id=7a39957e&"
import script from "./NoSections.vue?vue&type=script&lang=js&"
export * from "./NoSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports